import React from 'react'
import './Navbar.css'

function Navbar() {
  return (
    <div className='NavContainer'>
        <div className='Rightone'>
            <li>Add Restaurant</li>
            <li>Log in</li>
            <li>Sign up</li>
        </div>
    </div>
  )
}

export default Navbar